import { Box, Checkbox } from '@mui/material';
import {
  StyledModalContentRow,
  modalContentSide,
  StyledDisplayName,
  StyledModalContentSide,
  gatewayNameBox,
  StyledGatewayNameLabel,
  assetNameLabelBox,
  StyledAssetNameLabel,
} from 'src/features/trends/components/modal-content-row/style';
import { useResponsive } from 'src/hooks/useResponsive';
import { TagResponse } from 'src/types/tags/tags';

type Props = {
  tag: TagResponse;
  checked: boolean;
  onToggle: () => void;
};

export const ModalContentItem = ({ tag, checked, onToggle }: Props) => {
  const isMobile = useResponsive('down', 'sm');

  return (
    <StyledModalContentRow onClick={onToggle}>
      <Box sx={modalContentSide}>
        <Checkbox checked={checked} inputProps={{ 'data-sm': tag.displayName }} />
        <StyledDisplayName isMobile={isMobile}>{tag.displayName}</StyledDisplayName>
      </Box>
      <StyledModalContentSide isMobile={isMobile}>
        {tag?.gatewayName ? (
          <Box sx={gatewayNameBox}>
            <StyledGatewayNameLabel variant="caption">{tag.gatewayName}</StyledGatewayNameLabel>
          </Box>
        ) : null}
        {tag?.connectedAsset ? (
          <Box sx={assetNameLabelBox}>
            <StyledAssetNameLabel variant="caption">{tag.connectedAsset}</StyledAssetNameLabel>
          </Box>
        ) : null}
      </StyledModalContentSide>
    </StyledModalContentRow>
  );
};
